import React, { createContext, useContext, useEffect, useState } from "react";
import { startOfMonth, todayISO } from "@/lib/format";

const STORAGE_KEY = "brandops.dateRange.v1";

const DateRangeContext = createContext(null);

function readInitial() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed?.dateFrom && parsed?.dateTo) return parsed;
  } catch {}
  return null;
}

export function DateRangeProvider({ children }) {
  const initial = readInitial() || { dateFrom: startOfMonth(), dateTo: todayISO() };
  const [dateFrom, setDateFromState] = useState(initial.dateFrom);
  const [dateTo, setDateToState] = useState(initial.dateTo);

  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify({ dateFrom, dateTo })); } catch {}
  }, [dateFrom, dateTo]);

  const setDateFrom = (v) => setDateFromState(v);
  const setDateTo = (v) => setDateToState(v);
  const setRange = (from, to) => { setDateFromState(from); setDateToState(to); };

  return (
    <DateRangeContext.Provider value={{ dateFrom, dateTo, setDateFrom, setDateTo, setRange }}>
      {children}
    </DateRangeContext.Provider>
  );
}

export function useDateRange() {
  const ctx = useContext(DateRangeContext);
  if (!ctx) throw new Error("useDateRange must be used within DateRangeProvider");
  return ctx;
}
